// @flow
export const SHIPPING_STATUS_WAITING: 'waiting' = 'waiting';
export const SHIPPING_STATUS_PROCESSING: 'processing' = 'processing';
export const SHIPPING_STATUS_SHIPPING: 'shipping' = 'shipping';
export const SHIPPING_STATUS_READY_FOR_ISSUE: 'ready_for_issue' = 'ready_for_issue';
export const SHIPPING_STATUS_ISSUED: 'issued' = 'issued';
export const SHIPPING_STATUS_PARTIALLY_ISSUED: 'partially_issued' = 'partially_issued';
export const SHIPPING_STATUS_CANCELED_BY_CUSTOMER: 'shipping_canceled_by_customer' = 'shipping_canceled_by_customer';

// export const SHIPPING_STATUS_READY_FOR_PICKUP: 'ready_for_pickup' = 'ready_for_pickup';
// export const SHIPPING_STATUS_SHIPPED: 'shipped' = 'shipped';
// export const SHIPPING_STATUS_DELIVERED: 'delivered' = 'delivered';
// export const SHIPPING_STATUS_SHIPPING_CANCELED: 'shipping_canceled' = 'shipping_canceled';
// export const SHIPPING_STATUS_RETURNED: 'returned' = 'returned';
// export const SHIPPING_STATUS_PARTIALLY_DELIVERED: 'partially_delivered' = 'partially_delivered';
